var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeynoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "keynote-icon-group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "keynote-icon-group2",
    transform: "translate(-93.000000, -606.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "keynote-icon-group3",
    transform: "translate(93.000000, 606.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "keynote-icon-polygon1",
    points: "0 0 32 0 32 32 0 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2162162,25.5255255 L28.2162162,6.69069069 C28.2162162,5.21081081 27.0054054,4 25.5255255,4 L6.69069069,4 C5.21081081,4 4,5.21081081 4,6.69069069 L4,25.5255255 C4,27.0054054 5.21081081,28.2162162 6.69069069,28.2162162 L25.5255255,28.2162162 C27.0054054,28.2162162 28.2162162,27.0054054 28.2162162,25.5255255 Z",
    id: "keynote-icon-path1",
    fill: "#3839BD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3657692,10.75 C12.3562419,10.8980165 9.96342104,13.4019615 10.0004234,16.4486335 C10.0497599,19.4829708 12.5165856,21.9622464 15.5507811,21.9992505 C18.6096449,22.0485894 21.1134729,19.6556567 21.2491483,16.6459888 C21.2614824,16.4979723 21.1381412,16.3746253 20.9901316,16.3746253 L15.8961367,16.3746253 C15.7481271,16.3746253 15.6247859,16.2512782 15.6247859,16.1155965 L15.6247859,11.0090288 C15.6247859,10.8610123 15.5137787,10.75 15.3657692,10.75 Z M16.75,10.2430676 L16.75,15.0077291 C16.75,15.1461696 16.8536184,15.25 16.9917763,15.25 L21.7582237,15.25 C21.8963816,15.25 22,15.1346329 22,14.9961924 C21.8733553,12.2966021 19.7088816,10.1277004 17.0032895,10.0007966 C16.8651316,9.98925992 16.75,10.104627 16.75,10.2430676 L16.75,10.2430676 Z",
    id: "keynote-icon-path2",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeynoteIcon);
export default __webpack_public_path__ + "static/media/keynote-icon.861e1bd0.svg";
export { ForwardRef as ReactComponent };